import { Message } from '@oneflowab/pomes';

import { isConcluded, isTemplate } from 'agreement';

import toast from 'components/toasts';
import { SIGNATURE_FIELD } from 'components/contract-boxes/constants';

import { UnassignedFieldsToastButton } from './unassigned-fields-toast-button';

export const UNASSIGNED_SIGNATURE_FIELDS_TOAST_ID = 'unassigned-signature-fields';

export const getUnassignedSignatureFields = (agreementData: Oneflow.Agreement['data']) => {
  if (!agreementData) {
    return [];
  }

  return agreementData?.filter(
    (each) => each?.key === SIGNATURE_FIELD && each?.value?.participant === null,
  );
};

export const renderGuestUnassignedFieldsToast = () => {
  toast.warning({
    id: UNASSIGNED_SIGNATURE_FIELDS_TOAST_ID,
    title: (
      <Message
        id="Unassigned Signature fields"
        comment="Info text explaining that the document has unassigned fields."
      />
    ),
    description: (
      <Message
        id="Contact the document owner to assign all the Signature fields."
        comment="Notification message for unassigned fields"
      />
    ),
  });
};

export const renderUnassignedFieldsToast = ({
  agreement,
  signAttempted,
  isGuest,
}: {
  agreement: Oneflow.Agreement,
  signAttempted: boolean,
  isGuest: boolean,
}) => {
  if (!signAttempted && (isGuest || isTemplate(agreement) || isConcluded(agreement))) {
    return;
  }

  const unassignedFields = getUnassignedSignatureFields(agreement.data);

  if (signAttempted && isGuest && unassignedFields.length > 0) {
    renderGuestUnassignedFieldsToast();
    return;
  }

  const shouldShowOwnerToast = unassignedFields.length > 0;

  if (shouldShowOwnerToast) {
    toast.warning({
      id: UNASSIGNED_SIGNATURE_FIELDS_TOAST_ID,
      title: (
        <Message
          id="Unassigned fields"
          comment="Info text explaining that the document has unassigned fields."
        />
      ),
      description: (
        <Message
          id="You have {count} unassigned Signature fields."
          comment="Info text explaining that if the user makes changes to the document or to the participants, the signatures might be reset."
          values={{ count: unassignedFields.length }}
        />
      ),
      action: <UnassignedFieldsToastButton />,
    });
  }
};
